/**
 * Is this page on an admin address of its own — a tenant's subdomain
 * (merit.hotwifi.in) or super.hotwifi.in — rather than the one the build's
 * REACT_APP_API_URL names (admin.hotwifi.in)? Then the API and /ws are this
 * same host's (the ingress routes them), so the backend sees which address the
 * admin is on: its branding and who may sign in there are that address's
 * (backend services/adminDomain.service.js). The captive portal's host
 * (REACT_APP_PORTAL_URL) keeps the API URL as it is.
 */
const hostOf = (url) => {
    try { return new URL(url, window.location.href).hostname.toLowerCase(); } catch (_) { return ''; }
};

export function onOwnAdminHost(apiUrl = process.env.REACT_APP_API_URL) {
    if (typeof window === 'undefined' || !apiUrl) return false;
    const here = window.location.hostname.toLowerCase();
    const apiHost = hostOf(apiUrl);
    if (!apiHost || apiHost === here) return false;
    const portalHost = process.env.REACT_APP_PORTAL_URL ? hostOf(process.env.REACT_APP_PORTAL_URL) : '';
    return here !== portalHost;
}
